import 'whatwg-fetch'
import { csrfRef } from '../../http'

const _request = async (endpoint, options) => {
  try {
    const newOptions = JSON.parse(JSON.stringify(options))
    if (csrfRef?.current) {
      newOptions.headers[csrfRef.current.headerName] = csrfRef.current.token
    }
    const res = await window.fetch(endpoint, newOptions)
    if (!res.ok) {
      const response = await res.json()
      throw new Error(response.message)
    }
    return await res.json()
  } catch (e) {
    throw e
  }
}

export const checkRedirect = () => {
  if (process.env.NODE_ENV === 'test') {
    return
  }
}

/**
 * @param withAuthCheck if set to true instance will check auth token before
 * PUT, POST and DELETE requests and reload page if close to expiry
 */
export default class Request {
  constructor(host, path, options, withAuthCheck = false) {
    this.host = host
    this.path = path
    this.options = options
    this.checkAuth = withAuthCheck
    this.baseUrl = `${host}${path}`
  }

  async get(options) {
    const requestOptions = Object.assign(
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      this.options,
      options,
    )
    const endpoint = this.baseUrl

    return _request(endpoint, requestOptions)
  }

  async put(id, data, options) {
    if (this.checkAuth) {
      checkRedirect()
    }
    const requestOptions = Object.assign(
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
      this.options,
      options,
    )
    const endpoint = `${this.baseUrl}/${id || ''}`

    return _request(endpoint, requestOptions)
  }

  async post(data, options) {
    if (this.checkAuth) {
      checkRedirect()
    }
    const requestOptions = Object.assign(
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
      this.options,
      options,
    )
    const endpoint = this.baseUrl

    return _request(endpoint, requestOptions)
  }

  async delete(id, options) {
    if (this.checkAuth) {
      checkRedirect()
    }
    const requestOptions = Object.assign(
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: '',
      },
      this.options,
      options,
    )
    const endpoint = `${this.baseUrl}/${id || ''}`

    return _request(endpoint, requestOptions)
  }
}
